import axios from "axios";
let base_url = "";
let mul_srvc = "";
if (process.env.REACT_APP_ENV === "development") {
    base_url = "https://gateway-dev.refactor.academy";
    mul_srvc = "https://proctorgateway-dev.refactor.academy";
}
else if (process.env.REACT_APP_ENV === "production") {
    base_url = "https://gateway-prod.refactor.academy";
    mul_srvc = "https://proctorgateway-prod.refactor.academy";
}
else if (process.env.REACT_APP_ENV === "staging") {
    base_url = "https://gateway-staging.refactor.academy";
    mul_srvc = "https://proctorgateway-staging.refactor.academy";
}
/**
 * Config api request
 **/
const apiClientServices = axios.create({
    baseURL: base_url,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
export const apiClientServicesProctoring = axios.create({
    baseURL: mul_srvc,
    headers: Object.assign({ "Content-Type": "application/json", Accept: "application/json" }, (sessionStorage.getItem("token") !== null && {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    })),
});
// apiClientServices.defaults.timeout = 3600;
export const setAuthorization = (token) => {
    console.log("setAuthorization called with token:", token);
    if (!token) {
        return;
    }
    apiClientServices.defaults.headers.common.Authorization = `Bearer ${token}`;
};
export const setAuthorizationProctoring = (token) => {
    if (!token) {
        return;
    }
    apiClientServicesProctoring.defaults.headers.common.Authorization = `Bearer ${token}`;
};
export const HandleError = (e) => {
    var _a;
    return (e === null || e === void 0 ? void 0 : e.response)
        ? ((_a = e.response.data) === null || _a === void 0 ? void 0 : _a.error) || e.response.data.errors
        : e.error || "Cannot connect to server";
};
export default apiClientServices;
